module.exports = __webpack_public_path__ + "img/orderlist.8b6a00ab.svg";